import {createSlice} from "@reduxjs/toolkit";

const initialState = {
    feedback_text: '',
    private_feedback_text: '',
    // service_feedback: {},
    photos_completed_order: [],
}

const feedbackCustomerSlice = createSlice({
    name: 'feedbackCustomerSlice',
    initialState,
    reducers: {
        setFeedbackText: (state, action) => {
            state.feedback_text = action.payload;
        },
        setPrivateFeedbackText: (state, action) => {
            state.private_feedback_text = action.payload;
        },
        setPhotosCompletedOrder: (state, action) => {
            state.photos_completed_order = action.payload;
        },
        clearAllData: (state) => {
            console.error('CLEAR')
            state.feedback_text = '';
            state.private_feedback_text = '';
            state.photos_completed_order = [];
        }
    }
});

const {actions, reducer: feedbackCustomerReducer} = feedbackCustomerSlice;

const feedbackCustomerActions = {
    ...actions,
}

export {
    feedbackCustomerReducer,
    feedbackCustomerActions,
}
